import { ArrowRightCircle } from "react-feather"
import { FiExternalLink } from "react-icons/fi";
// FiExternalLink

export default [

    {
        id: 'lesson-lesson',
        title: 'Цахим сургалт',
        navLink: "lesson/lesson/",
        // icon: <ArrowRightCircle color="#00c2bb"/>
        icon: <FiExternalLink />
    },
]